const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;

/**
 * How long ago something was said, in as few characters as it takes: `Just now`,
 * `9m`, `3h`, `2d`, then a date once "how long ago" stops being the useful answer.
 *
 * A comment card carries a byline per message in a column a few hundred pixels wide,
 * and a full date beside every name crowds out the name. Recency is what anyone reads
 * a thread for anyway — whether the last word landed a minute ago or last quarter.
 */
export function formatCommentTime(
  iso: string,
  now: number = Date.now()
): string {
  const date = new Date(iso);
  const time = date.getTime();
  if (Number.isNaN(time)) {
    return '';
  }

  const elapsed = now - time;
  // A clock a little behind the server's is not the future; it is now.
  if (elapsed < MINUTE_MS) {
    return 'Just now';
  }
  if (elapsed < HOUR_MS) {
    return `${Math.floor(elapsed / MINUTE_MS)}m`;
  }
  if (elapsed < DAY_MS) {
    return `${Math.floor(elapsed / HOUR_MS)}h`;
  }
  if (elapsed < WEEK_MS) {
    return `${Math.floor(elapsed / DAY_MS)}d`;
  }

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(date.getFullYear() !== new Date(now).getFullYear() && {
      year: 'numeric',
    }),
  });
}
